import styled from 'styled-components';

export const WrapperTag = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: auto;
    gap: 8px;
`;

export const TextTag = styled.span`
    font-family: Inter;
    font-size: 14px;
    font-weight: 500;
    line-height: 16.8px;
    letter-spacing: 0.016em;
    text-align: left;
    color: ${({ theme }) => theme.colors.button.text.disabled};
`;

export const ImageTag = styled.img`
    width: 17.08px;
    height: 17.08px;
`;
